﻿<template>
    <section class="mb-card">
        <div class="mb-card-body">
            <h3 class="mb-card-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                Change password
            </h3>

            <div class="mb-form-grid">
                <div class="mb-field">
                    <label for="current_password">Current password *</label>
                    <input type="password" name="current_password" id="current_password" autocomplete="current-password" v-model="current_password" class="mb-input" />
                </div>
                <div class="mb-field">
                    <label for="new_password">New password *</label>
                    <input type="password" name="new_password" id="new_password" autocomplete="new-password" v-model="new_password" class="mb-input" />
                </div>
                <div class="mb-field">
                    <label for="confirm_new_password">Confirm new password *</label>
                    <input type="password" name="confirm_new_password" id="confirm_new_password" autocomplete="new-password" v-model="confirm_new_password" class="mb-input" />
                </div>
            </div>

            <div class="mb-form-actions">
                <button type="button" class="button full" :disabled="saving_details" @click="Save_Details()">
                    <svg v-if="saving_details" class="mb-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" />
                        <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                    </svg>
                    {{ saving_details ? 'Saving…' : 'Save new password' }}
                </button>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./change_account_password.ts"></script>